import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CandidateProAction2 } from "../../../Redux/action/CandidateProAction2";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router";
import { CandidateProfile } from "../../../Redux/action/CandidateProfileAction";
import { CandidateProAction } from "../../../Redux/action/CandidateProAction";
import { CiEdit } from "react-icons/ci";
import { RiForbid2Line } from "react-icons/ri";
import { CandidateEducationAction } from "../../../Redux/action/CandidateEducationAction";
import { Link } from "react-router-dom";
import Modal from "../../Common/Modal/Modal";
import CandidateCertificationReducer from "../../../Redux/reducer/CandidateCertificationReducer";
import { CandidateCertificationAction } from "../../../Redux/action/CandidateCertificationAction";
import { TbExternalLink } from "react-icons/tb";
import { MdDeleteOutline } from "react-icons/md";
import Swal from "sweetalert2";
import axios from "axios";
import ViewCertificate from "./ViewCertificate";
import { FaEye } from "react-icons/fa";

const Certifications = () => {
  const [loading, setLoading] = useState(false);

  const { userResult } = useSelector((state) => state.Auth);
  const candidateId = userResult?.userid;
  const [isDisabled, setIsDisabled] = useState(false);
  const [viewCer, setViewCer] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [certiData, setCertiData] = useState({
    courseName: "",
    duration: "",
    certificationId: "",
    durationUnit: "",
    year: "",
    certificationUrl: "",
    courseProvider: "",
  });

  const certificates = useSelector(
    (state) => state?.Profile?.result?.candidateCertificate
  );
  const [certificateData, setCertificateData] = useState({
    candidateId: candidateId,
    courseName: "",
    duration: "",
    certificationId: "",
    durationUnit: "",
    year: "",
    certificationUrl: "",
    courseProvider: "",
  });

  const {
    courseName,
    duration,
    certificationId,
    certificationUrl,
    year,
    courseProvider,
    durationUnit,
  } = certificateData;

  const [selectedImage, setSelectedImage] = useState(null);
  const [certificateId, setCertificateId] = useState("");
  const [isDeleteImage, setIsDeleteImage] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const baseUrl = process.env.REACT_APP_API_PATH;

  const token = userResult?.token;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCertificateData({ ...certificateData, [name]: value });
  };

  useEffect(() => {
    dispatch(CandidateProfile(candidateId));
  }, [selectedImage]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleAddCertificationClick = () => {
    setIsModalOpen(true);
    setCertificateData({
      courseName: "",
      duration: "",
      certificationId: "",
      durationUnit: "",
      certificationUrl: "",
      year: "",
      courseProvider: "",
    });

    setSelectedImage(null);
  };

  const handleImageChange = (e) => {
    setIsDisabled(false);
    const file = e.target.files[0];
    const filesize = file.size / 1024 / 1024;
    if (filesize < 1) {
      setSelectedImage(file);
    } else {
      setIsDisabled(true);
      toast.error("File size should be less than 1MB");
      setSelectedImage(null);
      e.target.value = "";
    }
  };

  const removeImage = () => {
    setIsDeleteImage(true);
    setSelectedImage(null);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
  };

  const handleAddCertification = (e) => {
    e.preventDefault();

    if (!/^[A-Za-z\s.+#]+$/.test(courseName.trim())) {
      return toast.error(
        "Certificate name can only contain letters, spaces, and basic symbols like . + #"
      );
    }

    setLoading(true); // start loader

    let formData = new FormData();
    formData.append(
      "candidateCertificateRequest",
      JSON.stringify({
        candidateId,
        courseName,
        duration: duration + " " + durationUnit,
        certificationId,
        certificationUrl,
        year,
        courseProvider,
      })
    );

    if (selectedImage) {
      formData.append("image", selectedImage);
    }

    dispatch(CandidateCertificationAction(formData, navigate))
      .then((res) => {
        if (res?.data) {
          setTimeout(() => {
            dispatch(CandidateProfile(candidateId));
            setCertificateData({
              candidateId: "",
              courseName: "",
              duration: "",
              certificationId: "",
              certificationUrl: "",
              year: "",
              courseProvider: "",
            });

            setIsModalOpen(false);
            setSelectedImage(null);
            setLoading(false);
          }, 1200);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Add certificate failed:", err);
        setLoading(false);
      });
  };

  const handleUpdateCertification = async (e) => {
    e.preventDefault();

    if (!/^[a-zA-Z0-9]*$/.test(certificationId)) {
      return toast.error("Only alphanumeric characters allowed");
    }

    setLoading(true);

    let formData = new FormData();
    formData.append(
      "candidateCertificateRequest",
      JSON.stringify({
        courseName,
        duration: duration + " " + durationUnit,
        certificationId,
        certificationUrl,
        year,
        courseProvider,
        certificateId,
        isDeleteImage,
      })
    );

    if (selectedImage) {
      formData.append("image", selectedImage);
    }

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_PATH}/ebench/update_certificate`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status.success === true) {
        toast.success("Certificate updated successfully");
        setIsEditModalOpen(false);

        const timeout = setTimeout(() => {
          dispatch(CandidateProfile(candidateId));
        }, 1000);

        setCertificateData({
          candidateId: "",
          courseName: "",
          duration: "",
          certificationId: "",
          certificationUrl: "",
          year: "",
          courseProvider: "",
        });

        clearTimeout(timeout);
      } else {
        toast.error("Failed to update certificate");
      }
    } catch (error) {
      toast.error(error?.response?.data?.status?.message || "Update failed");
    }
    
    setLoading(false);
  };

  const handleDelete = async (certificateId) => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
          .custom-confirm-button {
              background-color: #286a94 !important;
              color: white;
              border-bottom: 1px solid rgb(57, 57, 57);
          }
          .custom-title {
              border-bottom: 0.5px solid #adadad;
              color: #286a94 !important;
              padding-bottom: 10px;
          }
              .msg-paragraph {
              margin-top:10px;
          }
        `;
    // Append the style to the head of the document
    document.getElementsByTagName("head")[0].appendChild(style);

    const para = document.createElement("div");
    para.className = "custom-paragraph";
    para.innerText = "Are you sure you want to delete?";
    const container = document.createElement("div");
    container.appendChild(para);

    Swal.fire({
      title: "Delete Certificate",
      html: container.outerHTML,
      showCancelButton: true,
      confirmButtonText: "Yes",
      customClass: {
        title: "custom-title",
        confirmButton: "custom-confirm-button",
      },
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            `${baseUrl}/ebench/delete_certificate?certificateId=${certificateId}`,
            {
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          );
          toast.success("Deleted Successfully");
          dispatch(CandidateProfile(candidateId));
          console.log("Delete API Response:", response.data);
          //   Swal.fire("Saved!", "", "success");
        } catch (error) {
          console.error("Error deleting project:", error);
          Swal.fire(
            "Error",
            "There was an error deleting the project",
            "error"
          );
        }
      } else if (result.isDenied) {
        // Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = 1970; year <= currentYear; year++) {
    years.push(year);
  }
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {!viewCer && (
        <div className="can_prof_container">
          <div className="">
            <div className="card can_prof_main">
              {
                <div className="card can_prof_main">
                  <div className="card-header common_table_header">
                    Certifications
                  </div>
                  <div className="card-body table-responsive">
                    {certificates && (
                      <table
                        class="table"
                        style={{
                          fontSize: "14px",
                          width: "100%",
                          textAlign: "center",
                        }}
                      >
                        <thead>
                          <tr style={{ textAlign: "center" }}>
                            <th className="fw_500" scope="col">
                              S.No
                            </th>
                            <th className="fw_500" scope="col">
                              Course Name
                            </th>
                            <th className="fw_500" scope="col">
                              Duration
                            </th>
                            <th className="fw_500" scope="col">
                              Certification Id
                            </th>
                            {/* <th className="fw_500" scope="col">
											Required Experience
										</th> */}
                            {/* <th className="fw_500" scope="col">
                                                Course Provider
                                            </th>
                                            <th className="fw_500" scope="col">
                                                Completion Year
                                            </th> */}
                            <th className="fw_500" scope="col">
                              View
                            </th>
                            <th className="fw_500" scope="col">
                              Actions
                            </th>
                            {/* <th className="fw_600" scope="col" colSpan={2}>Actions</th> */}
                          </tr>
                        </thead>
                        <tbody
                          className="skill_table_body"
                          style={{ textAlign: "center" }}
                        >
                          {certificates &&
                            certificates.map((item, index) => (
                              <tr key={index}>
                                <td scope="row">{index + 1}</td>

                                <>
                                  <td>{item.courseName || "N/A"}</td>
                                  <td> {item.duration || "N/A"}</td>
                                  <td>{item.certificationId || "N/A"}</td>
                                  {/* <td>{item.certificateImageUrl}</td> */}
                                  {/* <td>{item.courseProvider || 'N/A'}</td>
                                                        <td>{item.year || 'N/A'}</td> */}
                                </>
                                <td
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    setViewCer(true);
                                    setCertiData({
                                      courseName: item.courseName,
                                      duration: item.duration,
                                      certificationId: item.certificationId,
                                      durationUnit: item.durationUnit,
                                      year: item.year,
                                      certificationUrl: item.certificationUrl,
                                      imgUrl: item.certificateImageUrl,
                                      courseProvider: item.courseProvider,
                                    });
                                  }}
                                >
                                  <FaEye
                                    size={25}
                                    color="#286a94"
                                    className=""
                                  />
                                </td>
                                {/* <td>
                                                        {item.certificateImageUrl ? <a href={item.certificateImageUrl} target='_blank' rel="noreferrer" ><TbExternalLink size={25} color="#286a94" className="" /></a> : 'N/A'}
                                                    </td> */}
                                <td colSpan={2}>
                                  <div style={{ display: "flex" }}>
                                    <CiEdit
                                      size={25}
                                      color="#286a94"
                                      className="pointer me-2"
                                      onClick={() => {
                                        // Extract numeric value from duration string
                                        const durationNumeric = parseInt(
                                          item.duration.match(/\d+/)[0]
                                        );
                                        // Determine duration unit
                                        const durationUnit =
                                          item.duration.includes("Months")
                                            ? "Months"
                                            : "Years";
                                        // Set certificateData state
                                        setCertificateData({
                                          candidateId: item.candidateId,
                                          courseName: item.courseName,
                                          duration: durationNumeric, // Set numeric value of duration
                                          durationUnit: durationUnit, // Set duration unit
                                          certificationId: item.certificationId,
                                          certificationUrl:
                                            item.certificationUrl,
                                          year: item.year,
                                          courseProvider: item.courseProvider,
                                        });

                                        setSelectedImage(
                                          item.certificateImageUrl
                                        );
                                        setCertificateId(item.certificateId);
                                        setIsEditModalOpen(true);
                                      }}
                                    />
                                    <MdDeleteOutline
                                      size={25}
                                      color="red"
                                      className="pointer"
                                      onClick={() =>
                                        handleDelete(item.certificateId)
                                      }
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    )}

                    {certificates.length === 0 && (
                      <h5 style={{ textAlign: "center", fontSize: "16px" }}>
                        No data available
                      </h5>
                    )}
                  </div>
                </div>
              }
            </div>

            <div
              className="d-flex justify-content-left "
              style={{ boxShadow: "none" }}
            >
              <p
                className=" mt-5 pointer common_btn_outline2"
                onClick={handleAddCertificationClick}
              >
                Add Certification
              </p>
            </div>
          </div>
        </div>
      )}
      {viewCer && (
        <ViewCertificate
          viewCer={viewCer}
          setViewCer={setViewCer}
          data={certiData}
        />
      )}
      {isModalOpen && (
        <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
          <p style={{ padding: "0px" }} className="common_table_header">
            Add Certification
          </p>
          <hr />
          <form onSubmit={handleAddCertification} className="card-body">
            <div className="row gx-3 mb-3">
              <div className="col-sm-4">
                <label className="small mb-1">
                  Course Name
                  <span
                    style={{ color: "red", paddingLeft: 4 }}
                    className="text-red-700 pl-[2px]"
                  >
                    *
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Course Name"
                  name="courseName"
                  value={certificateData.courseName}
                  onChange={handleInputChange}
                  maxLength={50}
                  required
                />
              </div>
              <div className="col-sm-4">
                <label className="small mb-1">
                  Duration
                  <span
                    style={{ color: "red", paddingLeft: 4 }}
                    className="text-red-700 pl-[2px]"
                  >
                    *
                  </span>
                </label>

                <select
                  name="duration"
                  style={{
                    borderRadius: "4px",
                    border: "1px solid lightgray",
                    width: "40%",
                    marginLeft: "-3px",
                  }}
                  className="form-control w-100"
                  value={certificateData.duration}
                  onChange={handleInputChange}
                  required
                >
                  <option value="" disabled selected>
                    Select an option
                  </option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                </select>
                {/* <input
                                    type="text"
                                    id="inputDuration"
                                    className="form-control"
                                    name="duration"
                                    placeholder='Course Duration'
                                    value={certificateData.duration}
                                    onChange={handleInputChange}
                                    onKeyPress={(e) => {
                                        if (e.key !== 'Enter' && !/^[0-9]*$/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    autoComplete='off'
                                    maxLength={2}
                                    required
                                /> */}
              </div>
              <div className="col-sm-4">
                <label className="small mb-1" style={{ visibility: "hidden" }}>
                  Duration
                  <span
                    style={{ color: "red", paddingLeft: 4 }}
                    className="text-red-700 pl-[2px]"
                  >
                    *
                  </span>
                </label>
                <select
                  name="durationUnit"
                  className="form-control w-100"
                  value={certificateData.durationUnit}
                  style={{
                    borderRadius: "4px",
                    border: "1px solid lightgray",
                    width: "40%",
                    marginLeft: "-3px",
                  }}
                  // onChange={(e)=> setDurationUnit(e.target.value)}
                  onChange={handleInputChange}
                  required
                >
                  <option value="" disabled selected>
                    Select an option
                  </option>
                  <option value="Weeks">Weeks</option>
                  <option value="Months">Months</option>
                  <option value="Years">Years</option>
                </select>
              </div>
            </div>
            <div className="row gx-3 mb-3">
              <div className="col-sm-4">
                <label className="small mb-1">
                  Certification ID
                  <span
                    style={{ color: "red", paddingLeft: 4 }}
                    className="text-red-700 pl-[2px]"
                  >
                    *
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Certification ID"
                  name="certificationId"
                  value={certificateData.certificationId}
                  onChange={handleInputChange}
                  required
                  maxLength={25}
                  pattern="^[a-zA-Z0-9]+$"
                  title="Only alphanumeric characters are allowed"
                />
              </div>
              <div className="col-sm-4">
                <label className="small mb-1">
                  Completion Year
                  <span
                    style={{ color: "red", paddingLeft: 4 }}
                    className="text-red-700 pl-[2px]"
                  >
                    *
                  </span>
                </label>
                <select
                  className="form-control"
                  required
                  name="year"
                  value={certificateData.year}
                  onChange={handleInputChange}
                >
                  <option value="" disabled selected>
                    Select Year
                  </option>
                  {years.map((value) => (
                    <option value={value}>{value}</option>
                  ))}
                </select>
              </div>
              <div className="col-sm-4">
                <label className="small mb-1">Certification URL</label>
                <input
                  type="url"
                  className="form-control"
                  placeholder="Certification URL"
                  name="certificationUrl"
                  value={certificateData.certificationUrl}
                  pattern="https://.*"
                  title="url should be start with https://"
                  onChange={(e) => {
                    const value = e.target.value;

                    const emojiRegex =
                      /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;

                    if (!emojiRegex.test(value)) {
                      handleInputChange(e); // Only update state if no emoji
                    }
                  }}
                  maxLength={250}
                />
              </div>
            </div>
            <div className="row gx-3 mb-3">
              <div className="col-sm-4">
                <label className="small mb-1">
                  Course Provider
                  <span
                    style={{ color: "red", paddingLeft: 4 }}
                    className="text-red-700 pl-[2px]"
                  >
                    *
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="courseProvider"
                  placeholder="Course Provider"
                  value={certificateData.courseProvider}
                  onChange={handleInputChange}
                  required
                  maxLength={50}
                />
              </div>

              <div className="col-sm-6">
                <label className="small mb-1">Image</label>
                <input
                  type="file"
                  id="file1"
                  className="form-control"
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </div>
            </div>

            <div className="col-sm-6">
              {selectedImage && (
                <>
                  <label className="small mb-3">Selected Image:</label>
                  <div className="d-flex justify-content-center align-items-center flex-column">
                    <img
                      src={URL.createObjectURL(selectedImage)}
                      style={{ width: "200px", marginRight: "10px" }}
                      alt="Selected Image"
                      className="img-fluid"
                    />
                    <div className="my-3">
                      <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={removeImage}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>

            {
              <p
                style={{ color: "blue", paddingLeft: "10px", fontSize: "14px" }}
              >
                Please upload a file greater than 4KB and smaller than 1MB.
              </p>
            }
            <div className="d-flex justify-content-center justify-content-md-start">
              <button
                style={{ background: "#286a94" }}
                disabled={isDisabled}
                type="submit"
                className="btn-primary common_btn"
              >
                Add
              </button>
            </div>
          </form>
        </Modal>
      )}

      {/* =========== update certificate modal============= */}

      {isEditModalOpen && (
        <Modal isOpen={isEditModalOpen} onClose={handleCloseEditModal}>
          <p style={{ padding: "0px" }} className="common_table_header">
            Update Certification
          </p>
          <hr />

          <form onSubmit={handleUpdateCertification} className="card-body">
            <div className="row gx-3 mb-3">
              <div className="col-sm-4">
                <label className="small mb-1" htmlFor="inputCourseName">
                  Course Name
                  <span
                    style={{ color: "red", paddingLeft: 4 }}
                    className="text-red-700 pl-[2px]"
                  >
                    *
                  </span>
                </label>
                <input
                  type="text"
                  id="inputCourseName"
                  className="form-control"
                  name="courseName"
                  value={certificateData.courseName}
                  onChange={handleInputChange}
                  maxLength={50}
                />
              </div>
              <div className="col-sm-4">
                <label className="small mb-1" htmlFor="inputDuration">
                  Duration
                  <span
                    style={{ color: "red", paddingLeft: 4 }}
                    className="text-red-700 pl-[2px]"
                  >
                    *
                  </span>
                </label>
                <select
                  name="duration"
                  style={{
                    borderRadius: "4px",
                    border: "1px solid lightgray",
                    width: "33%",
                    marginLeft: "-3px",
                  }}
                  className="form-control w-100"
                  value={certificateData.duration}
                  onChange={handleInputChange}
                  required
                >
                  <option value="" disabled selected>
                    Select an option
                  </option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                </select>
              </div>
              <div className="col-sm-4">
                <label
                  className="small mb-1"
                  style={{ visibility: "hidden" }}
                  htmlFor="inputDuration"
                >
                  Duration
                </label>
                <select
                  name="durationUnit"
                  className="form-select w-100"
                  value={certificateData.durationUnit}
                  style={{
                    borderRadius: "4px",
                    border: "1px solid lightgray",
                    width: "33%",
                    marginLeft: "-3px",
                  }}
                  // onChange={(e)=> setDurationUnit(e.target.value)}
                  onChange={handleInputChange}
                  required
                >
                  <option value="" disabled selected>
                    Select an option
                  </option>
                  <option value="Weeks">Weeks</option>
                  <option value="Months">Months</option>
                  <option value="Years">Years</option>
                </select>
              </div>
            </div>
            <div className="row gx-3 mb-3">
              <div className="col-sm-4">
                <label className="small mb-1" htmlFor="inputCertificationId">
                  Certification ID
                  <span
                    style={{ color: "red", paddingLeft: 4 }}
                    className="text-red-700 pl-[2px]"
                  >
                    *
                  </span>
                </label>
                <input
                  type="text"
                  id="inputCertificationId"
                  className="form-control"
                  name="certificationId"
                  value={certificateData.certificationId}
                  onChange={handleInputChange}
                  pattern="^[a-zA-Z0-9]+$"
                  title="Only alphanumeric characters are allowed"
                  maxLength={25}
                />
              </div>

              <div className="col-sm-4">
                <label className="small mb-1" htmlFor="inputCertificationUrl">
                  Completion Year
                  <span
                    style={{ color: "red", paddingLeft: 4 }}
                    className="text-red-700 pl-[2px]"
                  >
                    *
                  </span>
                </label>
                <select
                  className="form-control"
                  id="inputYear"
                  name="year"
                  value={certificateData.year}
                  onChange={handleInputChange}
                >
                  <option value="" disabled selected>
                    Select Year
                  </option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-sm-4">
                <label className="small mb-1" htmlFor="inputCertificationUrl">
                  Certification URL
                </label>
                <input
                  type="url"
                  className="form-control"
                  placeholder="Certification URL"
                  name="certificationUrl"
                  value={certificateData.certificationUrl}
                  pattern="https://.*"
                  title="url should be start with https://"
                  onChange={(e) => {
                    const value = e.target.value;

                    const emojiRegex =
                      /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;

                    if (!emojiRegex.test(value)) {
                      handleInputChange(e); // Only update state if no emoji
                    }
                  }}
                  maxLength={250}
                />
              </div>
            </div>

            <div className="row gx-3 mb-3">
              <div className="col-sm-4">
                <label className="small mb-1" htmlFor="inputCourseProvider">
                  Course Provider
                  <span
                    style={{ color: "red", paddingLeft: 4 }}
                    className="text-red-700 pl-[2px]"
                  >
                    *
                  </span>
                </label>
                <input
                  type="text"
                  id="inputCourseProvider"
                  className="form-control"
                  name="courseProvider"
                  value={certificateData.courseProvider}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Regex to detect emoji characters
                    const emojiRegex =
                      /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;

                    if (!emojiRegex.test(value)) {
                      handleInputChange(e); // Only update state if no emoji
                    }
                  }}
                  maxLength={50}
                />
              </div>

              <div className="col-sm-6">
                <label className="small mb-1" htmlFor="inputImage">
                  Image
                </label>
                <input
                  type="file"
                  id="inputImage"
                  className="form-control"
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </div>
            </div>

            <div className="col-sm-6">
              {selectedImage && (
                <>
                  <label className="small mb-3">Selected Image</label>
                  <div className="d-flex justify-content-center align-items-center flex-column">
                    <img
                      src={
                        typeof selectedImage === "string"
                          ? selectedImage
                          : URL.createObjectURL(selectedImage)
                      }
                      style={{ width: "200px", marginRight: "10px" }}
                      alt="certificate"
                      className="img-fluid"
                    />
                    <div className="my-3">
                      <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={removeImage}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
            {
              <p
                style={{ color: "blue", paddingLeft: "10px", fontSize: "14px" }}
              >
                Please upload a file greater than 4KB and smaller than 1MB.
              </p>
            }
            <div className="d-flex justify-content-center justify-content-md-start">
              <button
                type="submit"
                style={{ background: "#286a94" }}
                className="common_btn btn-primary"
              >
                Update
              </button>
            </div>
          </form>
        </Modal>
      )}
    </>
  );
};

export default Certifications;
